document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cart__nt-button');
  if (!btn) return;

  const closeBtn = document.querySelector('.cart-drawer__close-button');
  if (closeBtn) {
    closeBtn.click();  
  }
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.header-actions__cart-icon--has-cart');
  if (!btn) return;

    BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
    BSS_B2B.nt.initFunction();
    document.dispatchEvent(new Event("DOMContentLoaded"));

    const waitNt = setInterval(() => {
      const ntBtn = document.querySelector(".cart__nt-button");
      if (ntBtn) {
        clearInterval(waitNt);

        ntBtn.disabled = true;
        ntBtn.style.pointerEvents = "none";
        ntBtn.style.backgroundColor = "gray";
        ntBtn.classList.add("nt-disabled");

        setTimeout(() => {
          ntBtn.disabled = false;
          ntBtn.style.pointerEvents = "auto";
          ntBtn.style.backgroundColor = "black";
          ntBtn.classList.remove("nt-disabled");
        }, 1200);
      }
    }, 50);
});


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cart-items__remove');
  if (!btn) return;
  BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
});


